import request from '@/found/utils/request';
import Form, { formCreate } from '@/found/components/form';

export default {
  extends: Form,
  components: {},
  data() {
    return {
      formFunctionCode: 'red_packet_pool_form',
    };
  },
  methods: {
    // 设置rule
    setRule(item) {
      const v = item;
      return v;
    },
    // 表单渲染完成后回调
    formComplete() {
      if (this.formConfig.code === 'edit' || this.formConfig.code === 'view') {
        this.setValue(this.formConfig.row);
      }
    },
    // 提交
    submit() {
      const formData = this.getFormData(); // 获取表单的值
      if (formData) {
        let url = '/tax/v1/redPooolAccount/addRedPoolAccount';
        const params = { ...formData };

        if (this.formConfig.code === 'edit') {
          url = '/tax/v1/redPooolAccount/editRedPoolAccount';
          params.id = this.formConfig.row.id;
        }

        request.post(url, params).then((res) => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '操作成功',
            });
            this.$emit('onClose');
            this.$emit('onGetList');
          }
        });
      }
    },
  },
};
